module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getClerks
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hotel_id",
      "label": "酒店"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function () { return _vm.showHotel(scope); }
          }
        }, [_vm._v("查看酒店")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "label": "角色",
      "formatter": _vm.formatRole
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "mobile", $$v)
      },
      expression: "editForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "role"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.editForm.role),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "role", $$v)
      },
      expression: "editForm.role"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "审核不通过",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "店员",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "店长",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "销售员",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), (_vm.editForm.role !== 3) ? _c('el-form-item', {
    attrs: {
      "label": "酒店",
      "prop": "hotel_id"
    }
  }, [_c('el-select', {
    staticClass: "long-select",
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.editForm.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hotel_id", $$v)
      },
      expression: "editForm.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(hotel) {
    return _c('el-option', {
      key: hotel.id,
      attrs: {
        "label": ((hotel.tzName ? hotel.tzName : '') + "--" + (hotel.dltName ? hotel.dltName : '')),
        "value": hotel.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editForm.role === 3) ? _c('el-form-item', {
    attrs: {
      "label": "酒店",
      "prop": "hotel_ids"
    }
  }, [_c('el-select', {
    staticClass: "long-select",
    attrs: {
      "clearable": "",
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: (_vm.editForm.hotel_ids),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hotel_ids", $$v)
      },
      expression: "editForm.hotel_ids"
    }
  }, _vm._l((_vm.hotels), function(hotel) {
    return _c('el-option', {
      key: hotel.id,
      attrs: {
        "label": ((hotel.tzName ? hotel.tzName : '') + "--" + (hotel.dltName ? hotel.dltName : '')),
        "value": hotel.id
      }
    })
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "酒店名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "address", $$v)
      },
      expression: "addForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行卡",
      "prop": "bank_card"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.bank_card),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "bank_card", $$v)
      },
      expression: "addForm.bank_card"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看酒店"
    },
    model: {
      value: (_vm.modalVisible),
      callback: function($$v) {
        _vm.modalVisible = $$v
      },
      expression: "modalVisible"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.roleHotels
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tzName",
      "label": "同舟酒店名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dltName",
      "label": "代理通酒店名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tcName",
      "label": "同程酒店名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pigName",
      "label": "飞猪酒店名"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.hideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/~/vue-loader/lib/template-compiler?{"id":"data-v-6e15589b"}!./~/.pnpm/vue-loader@11.3.4_babel-core@6.26.3_css-loader@0.26.4_vue-template-compiler@2.7.16_webpack@2.7.0/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/audit/index.vue
// module id = 1134
// module chunks = 1